import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import StudentAccessFrequencyGauge from './StudentAccessFrequencyGauge';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';
import { StudentAccessFrequencyListService } from '../../services/CustomerSuccessKpiListService';

class StudentAccessFrequencyCompanyGaugeContainer extends React.Component {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    StudentAccessFrequencyListService.load();
  }

  render() {
    const data = toJS(StudentAccessFrequencyListService.getByCompanyId(this.props.companyId));
    return (
      <StudentAccessFrequencyGauge
        loading={
          StudentAccessFrequencyListService.fetchCurrent.fetching ||
          StudentAccessFrequencyListService.fetchPrevious.fetching
        }
        currentValue={data.current}
        previousValue={data.previous}
        onClickHistory={() =>
          CustomerSuccessHistoryService.openDialog('STUDENT_ACCESS_FREQUENCY', this.props.companyId)
        }
        formatter={StudentAccessFrequencyListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentAccessFrequencyCompanyGaugeContainer);
